import { isFunction } from "../TypeChecking/index.js";
import { adSlotPrebid } from "./prebidConf.js";
const PREBID_JS_URL = 'https://assets.fanpage.it/ciaoprebid-js/0.0.8-rc.2/doPrebid.js';
function isWindowWithPrebidjs(a) {
    return ("prebidjs" in a &&
        ("doPrebid" in a.prebidjs && isFunction(a.prebidjs.init)));
}
function getOrInitializePrebidjsTagSdk(window, userData, gdpr) {
    if (isWindowWithPrebidjs(window)) {
        return Promise.resolve(window.prebidjs);
    }
    return new Promise((resolve, reject) => {
        let script = window.document.querySelector(`script[src='${PREBID_JS_URL}']`);
        if (!script) {
            script = window.document.createElement("script");
            script.src = PREBID_JS_URL;
            script.async = true;
            script.onload = () => {
                if (isWindowWithPrebidjs(window)) {
                    const prebidjs = window.prebidjs;
                    prebidjs.init(window, () => {
                        console.log('[PREBID] Prebid.js initialized successfully');
                        resolve(prebidjs);
                    });
                }
                else {
                    reject('[PREBID] Prebid.js script loaded but SDK is not available.');
                }
            };
            script.onerror = () => {
                reject('[PREBID] Failed to load Prebid.js script.');
            };
            window.document.head.appendChild(script);
        }
        else {
            const checkPrebidInterval = setInterval(() => {
                if (isWindowWithPrebidjs(window)) {
                    clearInterval(checkPrebidInterval);
                    resolve(window.prebidjs);
                }
            }, 100);
            setTimeout(() => {
                clearInterval(checkPrebidInterval);
                reject('[PREBID] Timeout waiting for Prebid.js to initialize.');
            }, 10000);
        }
    });
}
export class PrebidjsImpl {
    window;
    gdprPromise;
    userData;
    constructor(window, gdprPromise, userData) {
        this.window = window;
        this.gdprPromise = gdprPromise;
        this.userData = userData;
    }
    loadSdk() {
        return getOrInitializePrebidjsTagSdk(this.window, this.userData, this.gdprPromise)
            .then((prebidjs) => {
            this.window.prebidjs = prebidjs;
            return prebidjs;
        })
            .catch((error) => {
            console.error(error);
            throw error;
        });
    }
    instreamVideoCase(adunitId) {
        let apnxcnf = adSlotPrebid.appnexus.placementId[adunitId] ? {
            bidder: 'appnexus',
            params: {
                placementId: adSlotPrebid.appnexus.placementId[adunitId]
            }
        } : null;
        let freewheel = adSlotPrebid.freewheel.zoneId[adunitId] ? {
            bidder: 'freewheel-ssp',
            params: {
                zoneId: adSlotPrebid.freewheel.zoneId[adunitId]
            }
        } : null;
        let seedtag = adSlotPrebid.seedtag.video[adunitId].publisherId ? {
            bidder: 'seedtag',
            params: {
                ...adSlotPrebid.seedtag.video[adunitId]
            },
            ortb2Imp: {
                ext: {
                    gpid: adSlotPrebid.seedtag.video[adunitId].gpid
                },
                data: {
                    pbadslot: adSlotPrebid.seedtag.video[adunitId].gpid
                }
            }
        } : null;
        let pubmaticcnf = adSlotPrebid.pubmatic_apex.video[adunitId] ? {
            bidder: 'pubmatic_apex',
            params: {
                ...adSlotPrebid.pubmatic_apex.video[adunitId],
            },
        } : null;
        let pubmcnf = adSlotPrebid.pubmatic.video[adunitId] ? {
            bidder: 'pubmatic',
            params: {
                ...adSlotPrebid.pubmatic.video[adunitId],
            },
        } : null;
        let improvecnf = adSlotPrebid.improve.video[adunitId] ? {
            bidder: 'improvedigital',
            params: {
                ...adSlotPrebid.improve.video[adunitId],
            },
        } : null;
        let rubiconcnf = adSlotPrebid.rubicon.video[adunitId] ? {
            bidder: 'rubicon',
            params: {
                ...adSlotPrebid.rubicon.video[adunitId],
            },
        } : null;
        let ix = adSlotPrebid.ix.video[adunitId] && adSlotPrebid.ix.video[adunitId].siteId ? {
            bidder: 'ix',
            params: {
                siteId: adSlotPrebid.ix.video[adunitId].siteId
            },
            ortb2Imp: {
                ext: {
                    gpid: adSlotPrebid.ix.video[adunitId].gpid
                }
            }
        } : null;
        let yobee = adSlotPrebid.yobee.video[adunitId] ? {
            bidder: 'yobee',
            params: {
                networkId: adSlotPrebid.yobee.video[adunitId].networkId,
                host: adSlotPrebid.yobee.video[adunitId].host
            },
            ortb2Imp: {
                ext: {
                    gpid: adSlotPrebid.yobee.video[adunitId].gpid
                }
            }
        } : null;
        let criteo = adSlotPrebid.criteo.video[adunitId] && adSlotPrebid.criteo.video[adunitId].siteId ? {
            bidder: 'criteo',
            params: {
                pubid: adSlotPrebid.criteo.video[adunitId].pubid,
                networkId: adSlotPrebid.criteo.video[adunitId].networkId
            },
            ortb2Imp: {
                ext: {
                    gpid: adSlotPrebid.criteo.video[adunitId].gpid
                },
                data: {
                    pbadslot: adSlotPrebid.criteo.video[adunitId].pbadslot
                }
            }
        } : null;
        if (adSlotPrebid.criteo.video[adunitId] && adSlotPrebid.criteo.video[adunitId].gpid && adSlotPrebid.criteo.video[adunitId].pbadslot) {
            criteo.ortb2Imp.ext.gpid = adSlotPrebid.criteo.video[adunitId].gpid;
            criteo.ortb2Imp.data.pbadslot = adSlotPrebid.criteo.video[adunitId].pbadslot;
        }
        let bidsConf = [];
        if (apnxcnf)
            bidsConf.push(apnxcnf);
        if (pubmaticcnf)
            bidsConf.push(pubmaticcnf);
        if (rubiconcnf)
            bidsConf.push(rubiconcnf);
        let randomizableBidders = [];
        if (pubmcnf)
            randomizableBidders.push(pubmcnf);
        if (freewheel)
            randomizableBidders.push(freewheel);
        if (improvecnf)
            randomizableBidders.push(improvecnf);
        if (seedtag)
            randomizableBidders.push(seedtag);
        if (ix)
            randomizableBidders.push(ix);
        if (criteo)
            randomizableBidders.push(criteo);
        if (yobee)
            randomizableBidders.push(yobee);
        this.shuffleArray(randomizableBidders);
        bidsConf.push(...randomizableBidders);
        console.log('[PREBID] Video Bidders Order:');
        bidsConf.forEach((bidder, index) => {
            console.log(`  ${index + 1}. ${bidder.bidder}: ${JSON.stringify(bidder)}`);
        });
        return bidsConf;
    }
    shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
    }
    displayCase(adunitId) {
        if (document.body.classList.contains('postid-430'))
            adSlotPrebid.appnexus.placementId = { kodami_overlayer: 35463873 };
        let pbmaticnf = (adSlotPrebid.pubmatic.display[adunitId] && adSlotPrebid.pubmatic.display[adunitId].publisherId) ? {
            bidder: 'pubmatic',
            params: {
                publisherId: adSlotPrebid.pubmatic.display[adunitId].publisherId,
                adSlot: adSlotPrebid.pubmatic.display[adunitId].adSlot,
            }
        } : null;
        let pbmaticapexcnf = (adSlotPrebid.pubmatic_apex.display[adunitId] && adSlotPrebid.pubmatic_apex.display[adunitId].publisherId) ? {
            bidder: 'pubmatic_apex',
            params: {
                publisherId: adSlotPrebid.pubmatic_apex.display[adunitId].publisherId,
                adSlot: adSlotPrebid.pubmatic_apex.display[adunitId].adSlot,
            }
        } : null;
        let apnxcnf = adSlotPrebid.appnexus.placementId[adunitId] ? {
            bidder: 'appnexus',
            params: {
                placementId: adSlotPrebid.appnexus.placementId[adunitId]
            }
        } : null;
        let taboolacnf = (adSlotPrebid.taboola.display[adunitId] && adSlotPrebid.taboola.display[adunitId].publisherId) ? {
            bidder: 'taboola',
            params: {
                publisherId: adSlotPrebid.taboola.display[adunitId].publisherId,
                tagId: adunitId,
            }
        } : null;
        let rubiconcnf = (adSlotPrebid.rubicon.display[adunitId]) ? {
            bidder: 'rubicon',
            params: {
                ...adSlotPrebid.rubicon.display[adunitId],
            }
        } : null;
        let seedtag = adSlotPrebid.seedtag.display[adunitId] ? {
            bidder: 'seedtag',
            params: {
                ...adSlotPrebid.seedtag.display[adunitId]
            },
            ortb2Imp: {
                ext: {
                    gpid: adSlotPrebid.seedtag.display[adunitId].gpid
                },
                data: {
                    pbadslot: adSlotPrebid.seedtag.display[adunitId].gpid
                }
            }
        } : null;
        let yobee = adSlotPrebid.yobee.display[adunitId] ? {
            bidder: 'yobee',
            params: {
                networkId: adSlotPrebid.yobee.display[adunitId].networkId,
                host: adSlotPrebid.yobee.display[adunitId].host
            },
            ortb2Imp: {
                ext: {
                    gpid: adSlotPrebid.yobee.display[adunitId].gpid
                },
                data: {
                    pbadslot: adSlotPrebid.yobee.display[adunitId].gpid
                }
            }
        } : null;
        let ix = adSlotPrebid.ix.display[adunitId] && adSlotPrebid.ix.display[adunitId].siteId ? {
            bidder: 'ix',
            params: {
                siteId: adSlotPrebid.ix.display[adunitId].siteId
            },
            ortb2Imp: {
                ext: {
                    gpid: adSlotPrebid.ix.display[adunitId].gpid
                }
            }
        } : null;
        let mobkoi = adSlotPrebid.mobkoi.display[adunitId] && adSlotPrebid.mobkoi.display[adunitId].placementId ? {
            bidder: 'mobkoi',
            params: {
                placementId: adSlotPrebid.mobkoi.display[adunitId].placementId
            },
            ortb2Imp: {
                ext: {
                    gpid: adSlotPrebid.mobkoi.display[adunitId].gpid
                }
            }
        } : null;
        let criteo = adSlotPrebid.criteo.display[adunitId] && adSlotPrebid.criteo.display[adunitId].siteId ? {
            bidder: 'criteo',
            params: {
                pubid: adSlotPrebid.criteo.display[adunitId].pubid,
                networkId: adSlotPrebid.criteo.display[adunitId].networkId
            },
            ortb2Imp: {
                ext: {
                    gpid: adSlotPrebid.criteo.display[adunitId].gpid
                },
                data: {
                    pbadslot: adSlotPrebid.criteo.display[adunitId].pbadslot
                }
            }
        } : null;
        let bidsConf = [];
        if (seedtag)
            bidsConf.push(seedtag);
        if (rubiconcnf)
            bidsConf.push(rubiconcnf);
        if (apnxcnf)
            bidsConf.push(apnxcnf);
        let randomizableBidders = [];
        if (pbmaticnf)
            randomizableBidders.push(pbmaticnf);
        if (pbmaticapexcnf)
            randomizableBidders.push(pbmaticapexcnf);
        if (taboolacnf)
            randomizableBidders.push(taboolacnf);
        if (ix)
            randomizableBidders.push(ix);
        if (mobkoi)
            randomizableBidders.push(mobkoi);
        if (criteo)
            randomizableBidders.push(criteo);
        if (yobee)
            randomizableBidders.push(yobee);
        this.shuffleArray(randomizableBidders);
        bidsConf.push(...randomizableBidders);
        console.log('[PREBID] Display Bidders Order:');
        bidsConf.forEach((bidder, index) => {
            console.log(`  ${index + 1}. ${bidder.bidder}: ${JSON.stringify(bidder)}`);
        });
        return bidsConf;
    }
    addGPID(adunitId) {
        if (adSlotPrebid.ix.video[adunitId] && adSlotPrebid.ix.video[adunitId].gpid)
            return {
                "ext": {
                    "gpid": adSlotPrebid.ix.video[adunitId].gpid
                }
            };
        return;
    }
    preparePrebidSlots(slots) {
        var preSlots = [];
        for (var s of slots) {
            var { id, sizes, adunitId } = s;
            var szs = sizes.filter(item => !(Array.isArray(item) ? item.includes('fluid') : item === 'fluid'));
            adunitId = adunitId.replace('/1010633/', '');
            let bidsConf = [];
            var videoType = 'outstream';
            var videoCode = '';
            if (adunitId.includes("_video")) {
                videoType = 'instream';
                bidsConf = this.instreamVideoCase(adunitId);
            }
            else
                bidsConf = this.displayCase(adunitId);
            if (!bidsConf.length)
                continue;
            var toPush = {
                code: id,
                mediaTypes: {},
                bids: bidsConf
            };
            if (videoType == 'instream') {
                toPush.mediaTypes.video = {
                    playerSize: sizes,
                    context: videoType,
                    mimes: ['video/mp4', 'video/webm', 'application/javascript'],
                    api: [1, 2, 3, 4, 5, 6, 7, 8],
                    plcmt: 1,
                    pos: 1,
                    skip: 1,
                    linearity: 1,
                    skipafter: 5,
                    skippable: true,
                    playbackmethod: s.videoParams && s.videoParams.playbackmethod ? s.videoParams.playbackmethod : [1, 2, 3, 4, 5, 6],
                    maxduration: 31,
                    minduration: 5,
                    startdelay: 0,
                    protocols: [1, 2, 3, 5, 6, 7, 8, 11, 12, 13, 14],
                    placement: 1,
                    minbitrate: 300,
                    maxbitrate: 9600,
                };
                toPush.code = adSlotPrebid.appnexus.code[adunitId];
            }
            else
                toPush.mediaTypes.banner = { sizes: szs };
            var ext = this.addGPID(adunitId);
            if (ext)
                toPush.ortb2Imp = ext;
            preSlots.push(toPush);
        }
        return Promise.resolve(preSlots);
    }
    washTargeting(targeting) {
        let cleanedTargeting = {};
        for (let key in targeting) {
            if (targeting.hasOwnProperty(key)) {
                let { hb_cache_host_pubmat, hb_uuid_pubmatic_ape, hb_format_pubmatic_a, hb_size_pubmatic_ape, hb_pb_pubmatic_apex, hb_adid_pubmatic_ape, hb_bidder_pubmatic_a, ...cleaned } = targeting[key];
                cleanedTargeting[key] = cleaned;
            }
        }
        return cleanedTargeting;
    }
    doPrebid(baseSlots) {
        return this.loadSdk()
            .then((prebidjs) => {
            return new Promise((resolve) => {
                this.preparePrebidSlots(baseSlots).then((slots) => {
                    prebidjs.doPrebid(slots, (bidsTarg) => {
                        console.log('[PREBID] Bids received:', bidsTarg);
                        resolve(bidsTarg);
                        return bidsTarg;
                    });
                });
            })
                .catch((error) => {
                console.error('[PREBID] Error during doPrebid:', error);
                throw error;
            });
        });
    }
}
